<template>
  <div>
    <div class="input-group">
      <input-item label="名称" :errTips="inputNameValidateResult">
        <el-input :id="focusID" @keyup.native.enter="okHandler" clearable autofocus v-model="inputName" placeholder="会话名" size="mini" class="input-item-value-one-line"></el-input>
      </input-item>
      <input-item label="协议">
        <el-select v-model="inputProtocol" placeholder="协议" size="mini" @keyup.native.enter="okHandler">
          <el-option label="ssh" value="ssh"></el-option>
          <el-option label="telnet" value="telnet"></el-option>
        </el-select>
      </input-item>
    </div>

    <div class="input-group">
      <input-item label="主机" :errTips="inputHostValidateResult">
        <el-input clearable autocomplete placeholder="主机 IP 或域名" @keyup.native.enter="okHandler" v-model="inputHost" size="mini" class="input-item-value-one-line" />
      </input-item>
      <input-item label="端口">
        <el-input-number v-model="inputPort" @keyup.native.enter="okHandler" :min="0" :max="65535" label="" size="mini" class="input-item-value-port" />
      </input-item>
    </div>

    <el-divider />

    <input-item label="认证方式" :errTips="inputUserValidateResult" class="input-item-auth">
      <el-radio v-model="inputAuthType" label="password">密码</el-radio>
      <el-tooltip class="item" effect="dark" content="通过服务端的公钥登陆，客户端需要提供对应的私钥" placement="top"><el-radio v-model="inputAuthType" label="publicKey">公钥</el-radio></el-tooltip>
    </input-item>

    <div class="input-group" v-show="inputAuthType !== 'none'">
      <input-item label="用户" :errTips="inputUserValidateResult">
        <el-input clearable autocomplete @keyup.native.enter="okHandler" placeholder="登陆的用户名" v-model="inputUser" size="mini" class="input-item-value-one-line" />
      </input-item>

      <input-item label="密码" v-show="inputAuthType==='password'">
        <el-input autocomplete show-password @keyup.native.enter="okHandler" v-model="inputPassword" label="用户密码" size="mini" class="input-item-one-line" />
      </input-item>
      <input-item label="用户密钥" v-show="inputAuthType==='publicKey'">
<!--        <el-input autocomplete show-password @keyup.native.enter="okHandler" v-model="inputPrivateKey" label="用户密钥" size="mini" class="input-item-one-line" />-->
        <el-select v-model="inputPrivateKey" placeholder="选择密钥" size="mini">
          <el-option v-for="k in keys" :key="k.name" :label="k.name" :value="k.name" />
        </el-select>
      </input-item>
    </div>

    <el-divider />

    <div class="input-group">
      <input-item label="附加" :errTips="inputDescriptionValidateResult">
        <el-input autocomplete type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="附加信息" v-model="inputDescription" />
      </input-item>
    </div>
  </div>
</template>

<script>
import model from '../../model'
import inputItem from './inputItem'
export default {
  name: "inputSession",
  props: ["title", "sess", "focusID", "sessDir", "validateFileExist"],
  components: {
    inputItem,
  },
  data() {
    return {
      inputName: "",
      inputProtocol: "ssh",
      inputHost: "",
      inputPort: 22,

      inputUser: "",
      inputAuthType: "none",  // "none"/"password"/"publicKey"
      inputPassword: "",
      inputPrivateKey: "",  // Private key name

      inputDescription: "",

      inputNameValidateResult: "",
      inputHostValidateResult: "",
      inputUserValidateResult: "",
      inputDescriptionValidateResult: "",

      keys: [],
    }
  },
  computed: {
    sessFilePath: function() {
      return `${this.env.sess.basePath}/${this.sessDir}/${this.inputName}`
    },
  },
  mounted() {
    this.updateInputVal(this.sess)
  },
  watch: {
    inputName: function() {
      this.updateSess()
      this.inputNameValidateResult = this.validateName()
    },
    inputProtocol: function() {this.updateSess()},
    inputHost: function() {
      this.updateSess()
      this.inputHostValidateResult = this.validateHost()
    },
    inputPort: function() {this.updateSess()},

    inputUser: function() {this.updateSess()},
    inputAuthType: function() {
      this.updateSess()

      // 每次 auth type 切换为 "publicKey" 都更新一下 keys
      if (this.inputAuthType === "publicKey") {
        this.updateKeys()
      }
    },
    inputPassword: function() {this.updateSess()},
    inputPrivateKey: function() {this.updateSess()},

    inputDescription: function() {
      this.updateSess()
      this.inputDescriptionValidateResult = this.validateDescription()
    },
  },
  methods: {
    okHandler() {
      this.$emit("ok")
    },
    updateInputVal(sess) {
      for (let key in sess) this[`input${key}`] = sess[key]
    },
    input2sess() {
      let s = new model.Session()
      for (let key in s) s[key] = this[`input${key}`]
      return s
    },
    updateSess() {  // 触发更新传递近期来的 Session 事件
      let s = this.input2sess()
      this.$emit('updateSession', s)
    },
    isInputValid() {
      this.validateAll()
      if (this.inputNameValidateResult === "" &&
          this.inputHostValidateResult === "" &&
          this.inputUserValidateResult === "" &&
          this.inputDescriptionValidateResult === "") {
        return true
      }
      return false
    },
    validateAll() {
      this.inputNameValidateResult = this.validateName()
      this.inputHostValidateResult = this.validateHost()
      this.inputDescriptionValidateResult = this.validateDescription()
    },
    validateName() {
      let self = this
      let ret = this.utils.validateFileName(this.inputName)

      if (this.validateFileExist === true && ret === "") {
        // 文件名规则校验通过，检查是否存在同名文件
        this.api.hifs.getPath(this.sessFilePath, (error, data, response) => {
          if (error) {
            self.api.errHandler(self, error, response)
          } else {
            // 会话文件已存在
            if (data == true) {
              self.inputNameValidateResult = `会话 "${self.inputName}" 已存在`
            }
          }
        })
      }

      return ret
    },
    validateHost() {
      let host = this.inputHost ? this.inputHost.trim() : ""
      if (host.length < 1) {
        return "*"
      }
      return ""
    },
    validateDescription() {
      let len = this.inputDescription ? this.inputDescription.length : 0
      if (len > 40960) {
        return `Max length: 40960, current length: ${len}`
      }
      return ""
    },
    updateKeys: function() {
      let self = this
      self.api.hifs.getDirSubsData(self.env.key.basePath, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
        } else {
          // console.log("data:", data)
          self.keys = [{name: "", raw: {}}]
          if (!data || !data.Files || data.Files.length < 1) return
          for (let f of data.Files) {
            let keyPair = this.model.NewKeyPairFromJSON(window.atob(f.Data))
            let k = {
              name: f.Name,
              raw: keyPair,
            }
            self.keys.push(k)
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.input-group {
  display: flex;
}
.input-item-value-port {
  flex-grow: 1;
  flex-shrink: 1;
}
.input-item-value-one-line {
  width: 15em;
}
</style>
